import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            fontFamily: 'Arial, sans-serif',
            color: '#333',
        }}>
            <h1 style={{ fontSize: '5rem', marginBottom: '1rem' }}>404</h1>
            <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
                Oops! The page you’re looking for doesn’t exist.
            </p>
            <Link
                to="/"
                style={{
                    textDecoration: 'none',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#ac130a',
                    color: 'white',
                    borderRadius: '4px',
                }}
            >
                Return Home
            </Link>
        </div>
    );
};

export default NotFound;
